import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 1H2v16h2V3h12V1zm-1 4l6 6v12H6V5h9zm-1 7h5.5L14 6.5V12z"
}), 'FileCopySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FileCopySharp.js
// module id = 3572
// module chunks = 2